"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
function SectionedContent(_ref) {
  let {
    sections = []
  } = _ref;
  const sectionHeaderMarkup = new Map([['primary', {
    open: "<h1 class=\"h2\">",
    close: "</h1>"
  }], ['secondary', {
    open: "<h2 class=\"h3\">",
    close: "</h2>"
  }]]);
  return /*#__PURE__*/_react.default.createElement("sectioned-content", null, sections.length && sections.map((section, index) => {
    if (section.content !== '') {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: "section-".concat(section.title, "-").concat(index)
      }, (0, _htmlReactParser.default)(sectionHeaderMarkup.get(section.header.type).open + section.header.title + sectionHeaderMarkup.get(section.header.type).close), typeof section.content === 'string' ? (0, _htmlReactParser.default)(section.content) : section.content);
    } else {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: "section--".concat(index)
      });
    }
  }));
}
var _default = exports.default = SectionedContent;